import { render, staticRenderFns } from "./EhrPatientBanner.vue?vue&type=template&id=c53eed8c&scoped=true&lang=pug"
import script from "./EhrPatientBanner.vue?vue&type=script&lang=js"
export * from "./EhrPatientBanner.vue?vue&type=script&lang=js"
import style0 from "./EhrPatientBanner.vue?vue&type=style&index=0&id=c53eed8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53eed8c",
  null
  
)

export default component.exports